import { useState } from 'react';
import { FaUser, FaLock } from 'react-icons/fa';

export default function AdminLogin({ setIsAdminAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === 'admin' && password === '123') {
      localStorage.setItem('isAdminAuthenticated', 'true');
      setIsAdminAuthenticated(true);
    } else {
      setErrorMessage('Usuário ou senha incorretos!');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-xs sm:max-w-md bg-white rounded-xlarge shadow-2xl p-4 sm:p-8 space-y-4 sm:space-y-6">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold text-black mb-2 sm:mb-4">Painel Administrativo</h2>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">Faça login para acessar</p>
        </div>
        
        {errorMessage && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-2 sm:px-4 py-2 sm:py-3 rounded text-sm sm:text-base relative" role="alert">
            {errorMessage}
          </div>
        )}
        
        <form onSubmit={handleLogin} className="space-y-3 sm:space-y-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-2 sm:pl-3 flex items-center pointer-events-none">
              <FaUser className="text-gray-400 text-sm sm:text-base" />
            </div>
            <input 
              type="text" 
              placeholder="Usuário"
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              required 
              className="w-full pl-8 sm:pl-10 pr-2 sm:pr-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
            />
          </div>
          
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-2 sm:pl-3 flex items-center pointer-events-none">
              <FaLock className="text-gray-400 text-sm sm:text-base" />
            </div>
            <input 
              type="password" 
              placeholder="Senha"
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              className="w-full pl-8 sm:pl-10 pr-2 sm:pr-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
            />
          </div>
          
          <button 
            type="submit" 
            className="w-full bg-orange-500 text-white py-2 sm:py-3 text-sm sm:text-base rounded-lg hover:bg-orange-600 transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300"
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
